import React from "react";

export default function NextBackButton({ callBack, goBack, showBackButton = true }) {
  return (
    <div className="bg-gray-light w-full py-7 mt-auto">
      <div className="py-6 flex flex-row justify-center">
        <div className="flex flex-col-reverse md:flex-row md:justify-evenly gap-6 md:space-x-40 md:space-y-0">
          {showBackButton && (
            <button
              className="hover:bg-gray-600 hover:outline-gray-600 bg-gray-500 py-1 px-14 text-white font-semibold text-xl outline-gray-500 outline-2 outline outline-offset-6 transition-all w-52 cursor-pointer"
              onClick={goBack}
            >
              Back
            </button>
          )}
          <button
            className="hover:bg-blue-dark hover:outline-blue-dark bg-blue-complimentary py-1 px-14 text-white font-semibold text-xl outline-blue-complimentary outline-2 outline outline-offset-6 transition-all w-52 cursor-pointer"
            onClick={() => callBack()}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
